/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePatientTicketSchema } from '../models/CreatePatientTicketSchema';
import type { PatientTicketDetailSchema } from '../models/PatientTicketDetailSchema';
import type { UpdatePatientTicketSchema } from '../models/UpdatePatientTicketSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PatientTicketsApi {
    /**
     * Create Patient Ticket
     * Assigns a season ticket to a patient. <br>Required Permission: create_patient_ticket
     * @returns PatientTicketDetailSchema Created
     * @throws ApiError
     */
    public static patientTicketsCreatePatientTicketPost({
        requestBody,
    }: {
        requestBody: CreatePatientTicketSchema,
    }): CancelablePromise<PatientTicketDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/patient-tickets/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Patient Ticket
     * Delete season ticket from a patient. <br>Required Permission: DELETE_PATIENT_TICKET
     * @returns void
     * @throws ApiError
     */
    public static patientTicketsDeletePatientTicketDelete({
        patientTicketId,
    }: {
        patientTicketId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/patient-tickets/{patient_ticket_id}/',
            path: {
                'patient_ticket_id': patientTicketId,
            },
        });
    }
    /**
     * Get Patient Ticket
     * Get patient ticket details.
     * @returns PatientTicketDetailSchema OK
     * @throws ApiError
     */
    public static patientTicketsGetPatientTicketGet({
        patientTicketId,
    }: {
        patientTicketId: string,
    }): CancelablePromise<PatientTicketDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/patient-tickets/{patient_ticket_id}',
            path: {
                'patient_ticket_id': patientTicketId,
            },
        });
    }
    /**
     * Update Patient Ticket
     * Updates a patient ticket. <br>Required Permission: update_patient_ticket
     * @returns PatientTicketDetailSchema OK
     * @throws ApiError
     */
    public static patientTicketsUpdatePatientTicketPut({
        patientTicketId,
        requestBody,
    }: {
        patientTicketId: string,
        requestBody: UpdatePatientTicketSchema,
    }): CancelablePromise<PatientTicketDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/patient-tickets/{patient_ticket_id}',
            path: {
                'patient_ticket_id': patientTicketId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
